import React from "react";
import { Shield, Upload, CheckCircle, AlertTriangle } from "lucide-react";

export default function KycVerification() {
  const status = "Pending"; // or "Verified"

  return (
    <div className="p-3 text-white text-[0.7rem] space-y-3">
      {/* Header */}
      <h1 className="text-[0.75rem] font-semibold flex items-center gap-2 text-slate-200 mb-2 tracking-wide">
        <Shield className="w-[14px] h-[14px] text-yellow-400" />
        KYC & Verification
      </h1>

      {/* Status Section */}
      <div className="bg-slate-900/70 border border-slate-800 rounded-md p-3">
        {status === "Verified" ? (
          <div className="flex items-center gap-2 text-green-400">
            <CheckCircle className="w-[12px] h-[12px]" />
            <p className="text-[0.68rem]">Your KYC is verified and active.</p>
          </div>
        ) : (
          <div className="flex items-center gap-2 text-yellow-400">
            <AlertTriangle className="w-[12px] h-[12px]" />
            <p className="text-[0.68rem]">Your KYC verification is pending.</p>
          </div>
        )}

        {/* KYC Fields */}
        <div className="mt-3 grid sm:grid-cols-2 gap-2">
          <KycField label="National ID / Passport" />
          <KycField label="Address Proof" />
          <KycField label="Selfie Verification" />
          <KycField label="Bank Account Proof" />
        </div>
      </div>
    </div>
  );
}

function KycField({ label }) {
  return (
    <div className="bg-slate-900/50 border border-slate-800 rounded-md p-2 flex flex-col gap-1 text-slate-400 text-[0.68rem]">
      <div className="flex items-center justify-between">
        <span className="truncate">{label}</span>
        <Upload
          className="w-[12px] h-[12px] text-blue-400 cursor-pointer hover:text-blue-300 transition"
          title="Upload document"
        />
      </div>
      <div className="text-[0.65rem] text-slate-500 italic">
        No file uploaded yet
      </div>
    </div>
  );
}
